import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import hydroponics_systems_net_pots2 from "../../Assets/hydroponics_systems_net_pots2.webp";
import hydroponics_systems_net_pots3 from "../../Assets/hydroponics_systems_net_pots3.webp";
import hydroponics_systems_net_pots4 from "../../Assets/hydroponics_systems_net_pots4.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tab, Nav, Carousel } from "react-bootstrap";
import "../../App.css";

const Net_pots_shop = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 60,
      name: "Twisted Rope (Tensioning Rope)",
      price: 250,
      image: hydroponics_systems_net_pots2,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-6">
          <Carousel>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={hydroponics_systems_net_pots2}
                alt="Net pots"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={hydroponics_systems_net_pots3}
                alt="hydroponic net pots"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={hydroponics_systems_net_pots4}
                alt="net pots shop"
              />
            </Carousel.Item>
          </Carousel>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">Hydroponic Net Pot</h2>
            <p className="product-price">
              <a href="/Contact" className="btn btn-link">
                Contact Us for Price Details
              </a>
            </p>

            {/* <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button> */}

            <div className="row mt-4">
              <div className="col-12">
                <p className="text-justify">
                  <h4>Essential Root Support for Hydroponic Systems</h4>
                  These high-quality hydroponic net pots are designed for
                  optimal root aeration and easy drainage, making them a perfect
                  fit for all hydroponic and aquaponic systems. The slotted mesh
                  structure allows roots to grow through and access
                  nutrient-rich water freely, encouraging strong and healthy
                  growth.
                </p>
                <i>Note: Minimum Order Quantity: 100 Units</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section with Border */}
      <div className="row mt-4">
        <div className="col-12 border-tabs">
          <Tab.Container defaultActiveKey="Specifications">
            <Nav variant="tabs" className="mb-3 custom-nav">
              <Nav.Item>
                <Nav.Link eventKey="Specifications" className="custom-tab">
                  Product Specifications
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Features" className="custom-tab">
                  Features
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="moreInfo" className="custom-tab">
                  Additional Information
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="Specifications">
                <ul>
                  <li>
                    <span className="fw-bold">Material(Filling):</span> Durable,
                    food-grade plastic
                  </li>
                  <li>
                    <span className="fw-bold">Design:</span> Slotted mesh for
                    optimal aeration and drainage
                  </li>
                  <li>
                    <span className="fw-bold">Compatibility:</span>Works with
                    most hydroponic systems including NFT, DWC, and aeroponics
                  </li>
                  <li>
                    <span className="fw-bold">Reusable:</span> Long-lasting and
                    easy to clean for multiple growing cycles
                  </li>
                  <li>
                    <span className="fw-bold">Support media:</span>Suitable for
                    use with coco peat, clay pebbles, rock wool, etc.
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="Features">
                <h4>Features</h4>
                <ul>
                  <li>
                    Scalable: Suitable for both hobby growers and commercial
                    farms
                  </li>
                  <li>
                    Efficient water use: Ideal for drain-to-waste or
                    recirculating systems
                  </li>
                  <li>
                    Clean root zone: Mesh structure enhances drainage and air
                    pruning
                  </li>
                  <li>
                    Modular Design: Easy to place, move, or swap individual
                    plants
                  </li>
                  <li>
                    Strong Build: Withstands long-term use, even in
                    high-humidity environments
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="moreInfo">
                <h4>Additional Information</h4>
                <ul>
                  <li>
                    <span className="fw-bold">Item Code:</span> RGCPL-0038
                  </li>
                  <li>
                    <span className="fw-bold">Delivery Time:</span> 7-8 Days
                  </li>
                  <li>
                    <span className="fw-bold">Port of Dispatch:</span>{" "}
                    Maharashtra, India
                  </li>
                  <li>
                    <span className="fw-bold">Production Capacity:</span> 5,000+
                    Units Per Day
                  </li>
                  <li>
                    <span className="fw-bold">Packaging Details:</span>{" "}
                    Corrugated boxes or customized as per client requirement
                  </li>
                  <li>
                    <span className="fw-bold">Payment Terms:</span> Advance
                    Payment
                  </li>
                  <li>
                    <span className="fw-bold">Payment Mode:</span> RTGS / NEFT /
                    IMPS
                  </li>
                </ul>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <h5 className="mt-3">Key Benefits:</h5>
        <ul>
          <li>
            Water & Nutrient Efficiency: Closed‑loop recirculation minimizes
            waste
          </li>

          <li>
            Consistent Root Zone: Uniform moisture and nutrient levels boost
            yields
          </li>

          <li>
            Modular Scalability: Add or rearrange buckets easily as your
            operation grows
          </li>

          <li>
            Low Labor & Maintenance: Simple installation and minimal upkeep
          </li>

          <li>
            Crop Flexibility: Perfect for any heavy‑feeding, fruiting, or vine
            crops
          </li>
        </ul>

        <h5 className="mt-3">Applications:</h5>
        <ul>
          <li>
            Commercial hydroponic farms cultivating tomatoes, cucumbers,
            peppers, eggplants
          </li>

          <li>Urban rooftop or indoor growing installations</li>

          <li>Greenhouses requiring modular, space‑efficient plant support</li>

          <li>
            Research and development in controlled‑environment agriculture (CEA)
          </li>
        </ul>
      </div>

      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Net_pots_shop;
